import React, { useState, useCallback } from 'react';
import WplFileUpload from "../../components/wpl-file-upload/WplFileUpload";
import { turbineAPI } from "../../api";
import { toPrettyDateStr } from "../../prettyDate";

export default function DmParseTurbines() {
  const [windfarmId, setWindfarmId] = useState(null);
  const [windfarmName, setWindfarmName] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [country, setCountry] = useState(null);
  const [endDate, setEndDate] = useState(() => toPrettyDateStr(new Date()));
  const [startDate, setStartDate] = useState(() => {
    const lastYear = new Date();
    lastYear.setFullYear(lastYear.getFullYear() - 1);
    return toPrettyDateStr(lastYear);
  });
  const [dataSource, setDataSource] = useState('DTN');
  const [messages, setMessages] = useState([]);

  const sources = ['DTN', 'SMHI', 'MET Norway', 'FMI', 'DMI'];

  const parseCSV = useCallback(async (filename, file_data) => {
    setMessages([]);

    const response = await turbineAPI.create_turbines_from_csv(
      filename,
      file_data,
      dataSource,
      startDate,
      endDate,
      country,
      {
        windfarm_id: windfarmId,
        windfarm_name: windfarmName,
        customer: customer
      }
    );

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');

    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      let lines = buffer.split('\n\n');
      buffer = lines.pop(); // Keep incomplete line

      for (const line of lines) {
        if (line.startsWith('data:')) {
          const message = line.replace(/^data:\s*/, '').trim();
          setMessages((prev) => [...prev, message]);
        }
      }
    }

  }, [windfarmId, windfarmName, customer, startDate, endDate, dataSource, country]);

  return (
    <div>
      <h1>Parse CSV and Create Turbines</h1>
      <a href="/lassie-template.csv" download>
        Download Template
      </a>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <h5>Select a windfarm ID or windfarm name + customer + country</h5>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <input
            value={windfarmId ?? ''}
            type="number"
            placeholder="Windfarm ID..."
            onChange={(e) => {
              const val = e.target.value;
              setWindfarmId(val === '' ? null : Number(val));
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <input
            value={windfarmName ?? ''}
            type="text"
            placeholder="Windfarm name..."
            onChange={(e) => {
              const val = e.target.value;
              setWindfarmName(val === '' ? null : val);
            }}
          />
          <input
            value={customer ?? ''}
            type="text"
            placeholder="Customer..."
            onChange={(e) => {
              const val = e.target.value;
              setCustomer(val === '' ? null : val);
            }}
          />
          <input
            value={country ?? ''}
            type="text"
            placeholder="Country..."
            onChange={(e) => {
              const val = e.target.value;
              setCountry(val === '' ? null : val);
            }}
          />
        </div>

        <h5>Select a time period and data source</h5>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}/>
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}/>
        </div>

        <div style={{ display: 'flex', gap: '1rem' }}>
          <select value={dataSource} onChange={(e) => setDataSource(e.target.value)}>
            <option value="" disabled hidden>Select data source</option>
            {sources.map((source) => (<option key={source} value={source}>{source}</option>))}
          </select>
        </div>

        <WplFileUpload
          asPopup={false}
          displayFiles={false}
          didSelectFile={parseCSV}
        />

        <div>
          <h2>Progress</h2>
          <ul>
            {messages.map((msg, idx) => (
              <li key={idx}>{msg}</li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
}
